// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emptyRow__VHkQK {
  height: 100px;
  background: var(--tables-primary-row-surface-default);
  text-align: center;
}

.noResultsIcon__VF06T path {
  fill: var(--tables-primary-row-icon);
}

.emptyRowBlock__cPt1U {
  text-align: center !important;
  padding: 50px 0px !important;
}

.emptyRowText__ALT8V {
  text-align: center;
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  width: 100%;
}

.emptyRowAdditionalText__mMiV2 {
  color: var(--tables-primary-row-text-additional);
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.11px;
}

.emptyRowTextWrapper__XsjQX {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/TableEmptyRowExtended/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,qDAAA;EACA,kBAAA;AAzEF;;AA6EE;EACE,oCAAA;AA1EJ;;AA8EA;EACE,6BAAA;EACA,4BAAA;AA3EF;;AA8EA;EACE,kBAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AA3EF;;AA8EA;EACE,gDAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AA3EF;;AA8EA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA3EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.emptyRow {\n  height: 100px;\n  background: var(--tables-primary-row-surface-default);\n  text-align: center;\n}\n\n.noResultsIcon {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.emptyRowBlock {\n  text-align: center !important;\n  padding: 50px 0px !important;\n}\n\n.emptyRowText {\n  text-align: center;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  width: 100%;\n}\n\n.emptyRowAdditionalText {\n  color: var(--tables-primary-row-text-additional);\n  text-align: center;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.11px;\n}\n\n.emptyRowTextWrapper {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyRow": `emptyRow__VHkQK`,
	"noResultsIcon": `noResultsIcon__VF06T`,
	"emptyRowBlock": `emptyRowBlock__cPt1U`,
	"emptyRowText": `emptyRowText__ALT8V`,
	"emptyRowAdditionalText": `emptyRowAdditionalText__mMiV2`,
	"emptyRowTextWrapper": `emptyRowTextWrapper__XsjQX`
};
module.exports = ___CSS_LOADER_EXPORT___;
